var map = {
	"./arrow-down-wide.svg": 39788,
	"./arrow-short.svg": 85806,
	"./arrows-right.svg": 67631,
	"./book.svg": 5787,
	"./calendar.svg": 74558,
	"./camera.svg": 53977,
	"./category-apple.svg": 1555,
	"./category-building.svg": 18477,
	"./category-democracy.svg": 16960,
	"./category-factory.svg": 29301,
	"./category-globe.svg": 96112,
	"./category-grain.svg": 51734,
	"./category-handshake.svg": 108,
	"./category-heart.svg": 9731,
	"./category-iceberg.svg": 66524,
	"./category-ocean.svg": 64205,
	"./category-oil-drum.svg": 90676,
	"./category-people.svg": 95968,
	"./category-sami.svg": 48859,
	"./category-science.svg": 62917,
	"./category-tree.svg": 45205,
	"./category-windmill.svg": 26201,
	"./chat.svg": 65366,
	"./checkmark.svg": 12791,
	"./clock.svg": 69222,
	"./close-small.svg": 92946,
	"./download-circle.svg": 43905,
	"./download-small.svg": 9654,
	"./download.svg": 49588,
	"./downtime.svg": 4651,
	"./error-page.svg": 85154,
	"./exclamation-mark-color.svg": 17905,
	"./exclamation-mark.svg": 20003,
	"./expand-collapse.svg": 29800,
	"./external-link-arrow.svg": 36402,
	"./facebook.svg": 42304,
	"./filter-small.svg": 85008,
	"./flag.svg": 20978,
	"./globe-old.svg": 95523,
	"./globe.svg": 47627,
	"./house.svg": 12944,
	"./info-color.svg": 16978,
	"./info.svg": 85968,
	"./link-arrow-circled.svg": 15619,
	"./link-arrow.svg": 25528,
	"./link.svg": 6524,
	"./linkedin.svg": 87906,
	"./long-arrow.svg": 39842,
	"./mail-square.svg": 14723,
	"./mail.svg": 26705,
	"./menu.svg": 1953,
	"./micro-arrow-down.svg": 89237,
	"./minus-small.svg": 30806,
	"./np-1.svg": 81476,
	"./np-2.svg": 24599,
	"./np-3.svg": 37062,
	"./np-4.svg": 39657,
	"./np-5.svg": 4792,
	"./np-6.svg": 43627,
	"./np-circle.svg": 35899,
	"./np-close.svg": 87401,
	"./np-dash-bottom-right.svg": 56808,
	"./np-dash-top-right.svg": 59344,
	"./np-dash-top-top.svg": 25039,
	"./np-long-horizontal.svg": 25386,
	"./np-long-vertical.svg": 95944,
	"./np-rectangle.svg": 31986,
	"./np-snake-horizontal.svg": 28258,
	"./np-snake-vertical.svg": 39888,
	"./open-arrow-circle.svg": 21141,
	"./person.svg": 28659,
	"./play.svg": 26706,
	"./plus-circle.svg": 33897,
	"./plus-small.svg": 23966,
	"./rss.svg": 31912,
	"./search.svg": 77072,
	"./share-big.svg": 61152,
	"./share-small.svg": 44311,
	"./slideshow.svg": 12072,
	"./small-arrow-down.svg": 35778,
	"./small-arrow-right.svg": 28788,
	"./sort-down.svg": 57625,
	"./sort-up.svg": 7126,
	"./star.svg": 17204,
	"./stop.svg": 16068,
	"./video.svg": 45157,
	"./volume.svg": 31754,
	"./warning-color.svg": 23586,
	"./warning.svg": 97408,
	"./x-circle.svg": 26921,
	"./x-straight.svg": 779,
	"./x.svg": 18140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62728;